// HummingbirdSDK.js
class HummingbirdSDK {
    constructor(config = {}) {
        this.baseURL = config.baseURL || '';
    }

    // Generic request method
    async request(endpoint, options = {}) {
        const url = `${this.baseURL}${endpoint}`;
        const headers = {
            'Content-Type': 'application/json',
        };

        try {
            const response = await fetch(url, {
                headers,
                ...options,
                body: options.body ? JSON.stringify(options.body) : undefined,
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            return data;
        } catch (error) {
            console.error('Hummingbird API Request failed:', error);
            throw error;
        }
    }

    // List devices by MAC addresses
    async listDevices(macAddresses) {
        return this.request('/listdevices', {
            method: 'POST',
            body: {
                mac_addresses: macAddresses,
            },
        });
    }
}

export default HummingbirdSDK;
